import { Radio } from 'antd';
import React from 'react';
import { Controller, useController, UseControllerProps } from 'react-hook-form';
import { handleError } from 'utils/component.util';

type RadioType = UseControllerProps & {
  options: { value: string | number; title: string }[];
  className?: string;
};
const FormRadio: React.FC<RadioType> = (props) => {
  const {
    fieldState: { error },
  } = useController(props);

  return (
    <div className={`relative ${props.className} min-w-[132px]`}>
      <Controller
        control={props.control}
        name={props.name}
        render={({ field: { onChange, value } }): JSX.Element => (
          <Radio.Group value={value} onChange={(e): void => onChange(e.target.value)}>
            {props.options.map((item) => (
              <Radio key={item.value} value={item.value}>
                {item.title}
              </Radio>
            ))}
          </Radio.Group>
        )}
      />
      <div>{handleError(error, props.rules)}</div>
    </div>
  );
};

export default FormRadio;
